module.exports = __webpack_public_path__ + "db6613d2a307990e3b568e34dea3d715.svg";